import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react';
import { useToasts } from '@/lib/toast';
import { cx } from './ui';

export function Toasts() {
  const { toasts, dismiss } = useToasts();
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[360px] max-w-[calc(100vw-2rem)] flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cx(
            'pointer-events-auto flex items-start gap-2.5 rounded-xl border bg-panel-2 px-3.5 py-3 text-sm shadow-2xl',
            t.kind === 'error' ? 'border-danger/40' : t.kind === 'success' ? 'border-ok/40' : 'border-line',
          )}
        >
          {t.kind === 'error' ? (
            <AlertCircle size={16} className="mt-0.5 shrink-0 text-danger" />
          ) : t.kind === 'success' ? (
            <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-ok" />
          ) : (
            <Info size={16} className="mt-0.5 shrink-0 text-accent-2" />
          )}
          <div className="flex-1 break-words">{t.message}</div>
          <button className="text-faint hover:text-fg" onClick={() => dismiss(t.id)} aria-label="Dismiss">
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
